import { Button } from "react-bootstrap"
import DataTable from "react-data-table-component"
import DataTableExtensions from 'react-data-table-component-extensions'
import "react-data-table-component-extensions/dist/index.css"
import { useTranslation } from "react-i18next"

export const CustomDataTable = (props) => {
    const { t } = useTranslation()

    const {columns, data, pagination = true, exportable = true, printable = true, expandedData, conditionalRowStyles = null} = props
  
    const tableData = {
        columns: columns,
        data: data,
        exportHeaders: true,
        print: printable,
        export: exportable,
        filterPlaceholder: t('datatables.buscar'),
        filterDigit: 3,
        filter: false
    }

    return (
        <>
            <DataTableExtensions {...tableData}>
                <DataTable
                    className="table table-sm table-striped table-bordered table-hover text-center"
                    noDataComponent={t('datatables.sinresultados')}
                    striped={true}
                    labelRowsPerPage={t('datatables.elementosporpagina')}
                    defaultSortField="_id"
                    defaultSortFieldId="_id"
                    defaultSortAsc={false}
                    expandableRows={!!expandedData}
                    expandableRowsComponent={expandedData ? expandedData : undefined}
                    pagination={!!pagination}
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    paginationPerPage = {25}
                    paginationServer={props.paginationServer}
                    paginationTotalRows={props.paginationTotalRows}
                    paginationDefaultPage={props.paginationDefaultPage}
                    paginationResetDefaultPage={props.paginationResetDefaultPage}
                    onChangePage={props.onChangePage}
                    onChangeRowsPerPage={props.onChangeRowsPerPage}
                    paginationComponentOptions={{
                        rowsPerPageText: t('datatables.elementosporpagina'),
                        rangeSeparatorText: t('datatables.de'),
                        noRowsPerPage: false,
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t('datatables.todos')
                    }}
                    conditionalRowStyles={conditionalRowStyles || []}
                />
            </DataTableExtensions>
        </>
    )
}